<template>
  <div class="page__wrapper" @scroll="onScroll()">
    <div class="flex">
      <div>
        <div @click="showWE = true">
          <p>West End</p>
          <FCNavButton text="Read More" />
        </div>
      </div>
      <div>
        <div @click="showOTR = true">
          <p>Over-The-Rhine</p>
          <FCNavButton text="Read More" @click="showOTR = true" />
        </div>
      </div>
    </div>
    <FCPopup
      v-if="showWE"
      title="West End"
      image="neighborhood/neighborhood-westend.jpg"
      :text="we"
      @close-popup="showWE = false"
    />
    <FCPopup
      v-if="showOTR"
      title="Over-The-Rhine"
      image="neighborhood/neighborhood-otr.jpg"
      :text="otr"
      @close-popup="showOTR = false"
    />
  </div>
</template>

<script>
import FCNavButton from "@/components/patterns/FCNavButton";
import FCPopup from "@/components/patterns/FCPopup";
export default {
  components: {
    FCNavButton,
    FCPopup,
  },
  mounted() {
    const ref = this.$store.state.menu.ourFans.ref;
    const index = this.$store.state.menu.menuItems
      .map((e) => e.ref)
      .indexOf(ref);
    this.$store.state.menu.activeSection = index;
    this.$store.state.menu.currentSectionTitle = this.$store.state.menu.ourFans.title;
    this.$store.state.menu.currentSectionNavigation = this.$store.state.menu.ourFans.nav;
    this.onScroll();
  },
  data() {
    return {
      h2: "Our Fans",
      h3: "Neighborhood",
      otr: `
        <p>Over-the-Rhine's rich culture is rooted in its history as a port-of-entry for immigrants to Cincinnati in the mid-to-late 1800s. In the nineteenth century, Over-the-Rhine was akin to a “Little Germany,” with a plethora of German food and historical Italianate architecture thatshaped the densely populated neighborhood. With beer an important aspect of German culture, breweries thrived in Over-the-Rhine, and 15 of the city’s 36 breweries were located in the neighborhood. Most Cincinnatians regarded Over-the-Rhine as the city's premier entertainment district.</p>
        <p>World Wars I and II and Prohibition drove most of the breweries out of business, and the neighborhood’s population declined dramatically. In 2006, Over-the-Rhine was placed on the National Trust for Historic Preservation's list of "Eleven Most Endangered Historic Places.”</p>
        <p>Led by the Cincinnati business community and civic leaders, Over-the-Rhine has been revitalized and remains one of the largest, most intact historic districts in the United States. The neighborhood has reclaimed its place as the city’s premier entertainment district, once again overflowing with restaurants, bars, breweries, shops, theatres and parks. Local chefs and artisan brewers embraced the revitalized neighborhood, and the 2018 Food & Wine Magazine called Over-the-Rhine "one of the country's most promising food scenes."</p>
      `,

      we: `
        <p>Located just west of Over-the-Rhine and just blocks northwest of downtown Cincinnati, the West End has a significant historical presence in Cincinnati. In the late 1800s, the West End was a thriving commercial district filled with meatpacking houses, breweries, wagon works and planing mills that employed thousands of local tradesmen and mechanics. The social scene in the neighborhood was vibrant as Central Avenue was home to 100 saloons, second in the city only to Vine Street with 136.  By the turn of the 20th century, the West End was home to prominent business owners, artists, and political leaders.</p>
        <p>Crosley Field was constructed in 1912 and was the long-time home of the Cincinnati Reds until 1970 when they moved to Riverfront Stadium. Unfortunately, much of the historical neighborhood was lost in the mid-twentieth century with the introduction of urban renewal projects, which included the construction of I-75.</p>
        <p>However, the West End is still home to several historic Cincinnati landmarks, including the districts of Dayton Street and Betts-Longworth, Cincinnati’s Union Terminal, and many buildingslisted on the National Historic Register. The area began to experience a renaissance several years before the announcement that the West End will officially become the home of FC Cincinnati in 2021. FC Cincinnati is proud to return professional sports to the neighborhood after a 51-year absence.</p>
      `,
      showOTR: false,
      showWE: false,
    };
  },
};
</script>

<style lang="scss">
.text p {
  margin-bottom: 15px;
}
</style>
<style lang="scss" scoped>
.page__wrapper {
  &::after {
    background-image: linear-gradient(
      0deg,
      rgba(5, 17, 42, 0.84) 52%,
      rgba(0, 0, 0, 0) 100%
    );
    position: absolute;
    right: 0;
    bottom: 0;
    width: 100%;
    min-height: 50%;
    pointer-events: none;
    content: " ";
  }
  background-image: url("~@/assets/backgrounds/bg-neighborhood.jpg");
  background-size: cover;
  background-position: center;
  padding-top: 0 !important;
  text-align: center;
  .text p {
    margin-bottom: 15px;
  }
  .flex {
    display: flex;
    align-items: flex-end;
    justify-content: center;
    position: relative;
    height: 100%;
    width: 100%;
    > div {
      flex-grow: 1;
      margin: 0 15px;
      text-align: center;
      margin-bottom: 200px;
      z-index: 1;
      > div {
        max-width: 355px;
        display: inline-block;
      }
    }
  }
  p {
    font-size: 42px;
    color: #ffffff;
    letter-spacing: 0;
    text-align: center;
    font-weight: bold;
    margin-bottom: 25px;
    text-transform: uppercase;
  }
  @media (max-width: 815px) {
    .flex > div {
      margin: 0;
      width: 100%;
      flex-grow: 0;
    }
    > div {
      flex-direction: column;
      align-items: center;
      justify-content: flex-end;
      padding-bottom: 15px;
      box-sizing: border-box;
      > div {
        margin: 0;
        flex-grow: 0;
      }
    }
    &::after {
      display: none;
    }
  }
}
</style>